














































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax';
import AbpBase from '../../../../lib/abpbase';
import SafetyBasic from './safetyBasic/index.vue';
import SafetyWork from './safetyWork/index.vue';
import SafetyCheck from './safetyCheck/index.vue';
import SafetyTrain from './safetyTrain/index.vue';
import SafetyProduct from './safetyProduct/index.vue';
import MajorHazard from './majorHazard/index.vue';
import ProductFacility from './productFacility/index.vue';
import SafetyAccident from './safetyAccident/index.vue';
import SpecialTypeOfWork from './specialTypeOfWork/index.vue';
import InfomationNet from './infomationNet/index.vue';
import EmergencyRescue from './emergencyRescue/index.vue';
import LaborDefense from './laborDefense/index.vue';
@Component({
    name:'safeAllManage',
    components: {
    	SafetyBasic,
    	SafetyWork,
    	SafetyCheck,
    	SafetyTrain,
    	SafetyProduct,
    	MajorHazard,
    	ProductFacility,
    	SafetyAccident,
    	SpecialTypeOfWork,
    	InfomationNet,
    	EmergencyRescue,
    	LaborDefense
    }
})
export default class SafeAllManage extends AbpBase {
    initData:any = {
        projectName: null,
        currentName: 'safeBase',
        pageCache: ['safeBase']
    }
    //切换详情内容
    Switch(name:any){
        this.initData.currentName = name;
        if(this.initData.pageCache.indexOf(name) == -1) {
        	this.initData.pageCache.push(name);
        }
    }
    showPage(name:any) {
    	if(this.initData.currentName == name || this.initData.pageCache.indexOf(name) >= 0) {
    		return true;
    	}
    	return false;
    }
    async mounted() {
    	
    }
}
